import React from 'react'
import MiniTesti from './subCmponents/miniTesti'
import firstimage from '../firstimage.jpg'
import secondimage from '../secondimage.jpg'
import thirdimage from '../thirdimage.jpg'

export default function Testimonials() {
  return (
   <div id="testimonials">
    <h1>What Our Users Say</h1>
    <p>Trusted by thousands of users worldwide</p>
    <div className="mini">
        <MiniTesti image={firstimage} comment="Tooliso delivered our platform 3x faster than expected — and it works flawlessly." profession="Small Business Owner" name="Sarah J."/>
        <MiniTesti image={secondimage} comment="Tooliso built our AI-powered MVP in just 8 weeks—turning my vision into a fundable product. We raised $2M within 3 months!" profession="Retail Manager" name="Priya K."/>
        <MiniTesti image={thirdimage} comment="As a teacher, I use the file converter almost daily to prepare materials for my students. It's reliable and works perfectly every time." profession="High School Teacher" name="Michael T."/>
    </div>
   </div>
  )
}
